import api from '@pray/shared/utils/api';

export async function schedulePrayTvContent({ artistId, contentId, publishedAt, sunsetAt }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');
  if (!publishedAt) throw Error('Published At is required');
  if (!sunsetAt) throw Error('Sunset At is required');

  const url = `/web/studio/artists/${artistId}/content/${contentId}/pray-tv-schedule`;
  const response = await api.executePostRequest(url, {
    published_at: publishedAt,
    sunset_at: sunsetAt,
  });

  return response.data;
}
